<script lang="ts">
  import { page } from '$app/stores';
  import Search from '$lib/search/search.svelte';
</script>

{#if $page.error?.code === 404}
  <h1>플레이어를 찾을 수 없습니다: {$page.error.message}</h1>
  <Search isStandalone />
{:else}
  <h1>{$page.status}: 예기치 못한 오류가 발생했습니다.</h1>
  {$page.error?.message}
{/if}
